import { blanchCoords } from '../../../constants';

export const MAP_CONFIG = {
  DEFAULT_CENTER: [blanchCoords[0], blanchCoords[1]] as [number, number],
  DEFAULT_ZOOM: 15,
  MIN_ZOOM_FOR_PLACES: 14,
  PLACE_LOAD_DEBOUNCE_MS: 300,
  SIGNIFICANT_MOVE_THRESHOLD: 0.001,
  ZOOM_RADIUS_MAP: {
    14: 2000,
    15: 1500,
    16: 1000,
    17: 750,
    18: 500,
    19: 300,
    20: 200,
  } as const,
  RISK_ASSESSMENT_RADIUS: 3.0,
  DEFAULT_CELL_ID: 7,
} as const;

export const MARKER_STYLES = {
  VERIFIED_COLOR: '#8B5CF6',
  UNVERIFIED_COLOR: '#3B82F6',
  DELETED_COLOR: '#6B7280',
  SELECTED_SIZE: 24,
  DEFAULT_SIZE: 16,
};

export const RISK_COLORS = {
  HIGH: '#DC2626',
  LOW: '#10B981',
  UNKNOWN: '#FFFFFF',
};
